module.exports = __webpack_public_path__ + "img/procuramiento.d1f27593.png";